//login without couchdb

import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Version from "../../../package.json";

// import komponen material-ui
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Swal from "sweetalert2";

import CircularProgress from "@material-ui/core/CircularProgress";

import PouchDB from "pouchdb-browser";

// import styles
import useStyles from "./styles";

// react router dom
import { Redirect } from "react-router-dom";

// pouchdb hook
import { usePouchDB } from "../../components/PouchDB/PouchDBProvider";

// app components
import AppLoading from "../../components/AppLoading";

import logo from "../../images/PK25.png";
import logoKominfo from "../../images/kominfologo.png";
import logoBkkbn from "../../images/LogoKemenduk.png";
import periode from "../../images/periode.png";
import { useSnackbar } from "notistack";

import cdb1 from "./cdb1.json";
import cdb2 from "./cdb2.json";
import cdb3 from "./cdb3.json";
import cdb4 from "./cdb4.json";
import dataKab from "./kabupaten.json";

import axios from "axios";

// const REACT_APP_COUCHDB_1_URL = process.env.REACT_APP_COUCHDB_1_URL
// const REACT_APP_COUCHDB_2_URL = process.env.REACT_APP_COUCHDB_2_URL
// const REACT_APP_COUCHDB_3_URL = process.env.REACT_APP_COUCHDB_3_URL
// const REACT_APP_COUCHDB_4_URL = process.env.REACT_APP_COUCHDB_4_URL
const REACT_APP_PK_RETRIEVE_URL = process.env.REACT_APP_API_CONFIG_URL_NEW;
const REACT_APP_API_CONFIG_URL = process.env.REACT_APP_API_CONFIG_URL;
const API_URL = process.env.REACT_APP_API_DEVELOPMENT_URL;
const USER_KEY_AUTH = process.env.REACT_APP_USER_KEY_AUTH;
const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
const id_provinsi = [11, 32, 33, 30, 31, 19, 20, 28, 23, 25];
const lock_id_kabupaten = [
  10, 20, 114, 51, 71, 78, 87, 77, 489, 488, 487, 486, 339, 340, 342, 330, 332,
  337, 531, 338, 172, 253, 359, 351, 343, 302, 306, 313, 310, 303, 308, 315,
  305, 312, 419, 421, 416, 420, 418, 417, 423, 441, 424, 425, 426, 427, 428,
  444, 429, 430, 431, 432, 433, 435, 437, 439, 436, 438, 440, 434, 442, 443,
  422, 477, 475, 476, 482, 483, 479, 480, 481, 484, 485, 529, 530, 478, 274,
  275, 276, 277, 278, 273, 272, 271, 270, 269, 267, 268, 280, 281, 282, 283,
  285, 284, 286, 287, 503, 279, 405, 406, 408, 409, 411, 410, 412, 414, 415,
  407, 413, 466, 467, 469, 470, 471, 472, 474, 507, 468, 473, 33,
];

function Login(props) {
  const API_CONFIG_URL = process.env.REACT_APP_API_CONFIG_URL;
  const dataFrontend = new PouchDB("frontend");
  const { location } = props;
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState({
    username: "",
    password: "",
  });
  const [isSubmitting, setSubmitting] = useState(false);
  const [onLogin, setOnLogin] = useState(false);
  const [onLogout, setOnLogout] = useState(false);
  const recaptchaRef = React.createRef();
  const [captcha, setCaptcha] = useState(false);
  const [globalPermit, setGlobalPermit] = useState(false);

  const [blocking, setBlocking] = React.useState(false);
  const [pgsPutCdb, setPgsPutCdb] = React.useState(false);
  const [labelPut, setLabelPut] = React.useState(
    "Please wait, checking data resource"
  );
  const [countPut, setCountPut] = React.useState(0);
  const [totalData, setTotalData] = React.useState(0);

  const { auth, user, setUser, logoutAndClearLocal, dataBkkbn } = usePouchDB();

  // const cekGlobalPermit = () => {
  //     axios.get(`${API_URL}/auth/getDatePBDKI`)
  //     .then((res) => {
  //         console.log(res, 'res getDate')
  //         if (res.status == "200") {
  //             setGlobalPermit(res.data)
  //         }else{
  //             enqueueSnackbar("ERROR : " + error.message, { variant: 'error' })
  //         }
  //     }).catch(function(error) {
  //         console.log("Err => ", error)
  //         enqueueSnackbar("CONNECTION ERROR : " + error.message, { variant: 'error' })
  //     })
  // }

  //cek GPS on
  const [locationUser, setLocationUser] = useState([]);

  const getLocationUser = () => {
    if (navigator.geolocation) {
      // console.log("Run Lokasi geo");
      navigator.geolocation.getCurrentPosition(function (position) {
        // console.log("Latitude xxx: ", position.coords.latitude);
        // console.log("Longitude xxx: ", position.coords.longitude);
        let arr = [
          {
            latitude: position.coords.latitude,
          },
          {
            longitude: position.coords.longitude,
          },
        ];
        setLocationUser(arr);
        localStorage.setItem("xsLocUser", JSON.stringify(arr));
      });
    } else {
      console.log("Not Run Lokasi if");
    }
  };

  useEffect(() => {
    getLocationUser();
  }, []);

  const checkVersion = async () => {
    const versi = Version.version;
    axios
      .get(`${API_CONFIG_URL}/pk/pwaConfig/getPWAVersion`, {
        // headers: { user_key: USER_KEY_PG }
        headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
      })
      .then((res) => {
        // console.log(res, "res version");
        if (res.status == "200") {
          if (res.data !== versi) {
            console.log("run beda versi");
            const clearCacheData = async () => {
              caches.keys().then(function (cacheNames) {
                cacheNames.forEach(function (cacheName) {
                  caches.delete(cacheName);
                });
              });
            };
            clearCacheData().then(console.log("clear chache jalan"));
            // clearCacheData().then(handleSignOut())
            // // clearCacheData().then(setUser({isLoggedIn: false,loading: true}))

            Swal.fire({
              title: "Peringatan",
              icon: "warning",
              text:
                "Terdapat perbedaan versi aplikasi dengan server, halaman akan dimuat ulang. Server version " +
                res.data,
            }).then(function () {
              window.location.reload();
            });
          }
        } else {
          enqueueSnackbar("ERROR : " + error.message, { variant: "error" });
        }
      })
      .catch(function (error) {
        console.log("Err => ", error);
        enqueueSnackbar(
          "Tidak ada koneksi internet untuk melakukan cek versi aplikasi : " +
            error.message,
          { variant: "info" }
        );
      });
  };

  useEffect(() => {
    // cekGlobalPermit()
    checkVersion();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
    setError({
      ...error,
      [e.target.name]: "",
    });
  };

  const validate = () => {
    const newError = { ...error };

    if (!form.username) {
      newError.username = "User wajib diisi";
    }

    if (!form.password) {
      newError.password = "Password wajib diisi";
    }

    if (locationUser.length === 0) {
      newError.password = "Location belum diaktifkan";
      let message = `Location belum diaktifkan, silakan buka pengaturan browser dan ijinkan aplikasi untuk mengakses Location`;
      enqueueSnackbar(message, { variant: "error" });
    }

    return newError;
  };

  useEffect(() => {
    const setSession = async () => {
      try {
        const session = user;
        // console.log(session, "session");
        if (session.userCtx.name) {
          // console.log("on login session");
          const metadata = user.metadata;

          setUser({
            isLoggedIn: true,
            loading: false,
          });

          const authData = {
            ...session.userCtx,
            isLoggedIn: true,
            metadata,
          };

          await dataFrontend.put({
            _id: "auth",
            authData,
          });

          // window.location.reload();
        } else {
          setUser({
            isLoggedIn: false,
            loading: false,
          });
        }
      } catch (e) {
        setUser({
          isLoggedIn: false,
          loading: false,
        });
      }
    };

    setSession();
  }, [onLogin]);

  useEffect(() => {
    if (onLogout) {
      console.log(onLogout, "run on logout");

      // localStorage.removeItem("db_name");
      // localStorage.removeItem("remote_base");
      // localStorage.removeItem("opr");
      // localStorage.removeItem("rw");
      logoutAndClearLocal();

      window.location.reload();
    }
  }, [onLogout]);

  const finishLogin = (username, res, opr) => {
    // console.log("run finish login");

    // id_provinsi.map(key => {
    //     if (key == provId) {
    //         localStorage.setItem("lock", false);
    //     }
    // })

    let id_rw = "false";
    const splitRw = form.username.split("_");
    if (username.substring(0, 3) == "opr") {
      if (splitRw.length > 1) {
        // let setRw = splitRw[splitRw.length - 1].substring(4)

        // === remove spasi sebelum RW ===
        // let setRw = splitRw[splitRw.length - 1].trimStart().toLowerCase()
        let setRw = splitRw[splitRw.length - 1];

        console.log(setRw, "<<<<<<< setRw");
        // let cek = res.data.userProfile.wil_rw.find(rw => { if (parseInt(rw.id_rw_bkkbn) === parseInt(setRw)) { return rw } return false })
        let cek = res.data.userProfile.wil_rw.find((rw) => {
          if (rw.nama_rw === setRw) {
            return rw;
          }
          return "false";
        });
        console.log(res.data.userProfile.wil_rw, "<<<<<< wil_rw");
        // console.log(cek, "<<<<<<<<< CEK A")
        if (cek) {
          // console.log(cek, "<<<<<<<<< CEK B")
          id_rw = cek.id_rw;
        }
      }
    }

    // console.log(id_rw, "<<<<< id_rw");

    localStorage.setItem("rw", id_rw);
    localStorage.setItem("lockTarget", "false");
    localStorage.setItem("lockWilayah", "false");

    let userCtx = {
      name: res.data.username,
      roles: res.data.userProfile.roles,
      id: res.data.id,
      ipAddress: res.data.ipAddress,
      jsessionid: res.data.jsessionid,
      flagFirstLogin: res.data.flagFirstLogin,
    };

    let metadata = res.data.userProfile;
    setUser((user) => ({
      ...user,
      userCtx,
      metadata: metadata,
    }));

    if (!id_rw && opr) {
      if (splitRw.length > 1) {
        enqueueSnackbar("User tidak terdaftar", { variant: "error" });
      }
    }

    setTimeout(() => {
      if (!id_rw && opr) {
        if (splitRw.length > 1) {
          setOnLogout(true);
        } else {
          setOnLogin(true);
        }
      } else {
        setOnLogin(true);
      }
    }, 1000);
  };

  // const retrievePk = async (rtRetrieve, username, res, opr) => {
  //     if (rtRetrieve.length > 0) {
  //         setBlocking(true)
  //         let dataRetrievePk = []
  //         try {
  //             const promises = rtRetrieve.map(async (el) => {
  //                 const resRetreievePk = await axios.post(REACT_APP_PK_RETRIEVE_URL + 'pk/api/v1/retrievePk?username='+username+'&idRt='+el, {
  //                     headers: {
  //                         Authorization: 'Basic ' + btoa('admin' + ':' + 'password'),
  //                         user_id : username
  //                     }
  //                 })
  //                 .then((res2) => {
  //                     dataRetrievePk = dataRetrievePk.concat(res2.data.data);
  //                 })
  //                 .catch(function (error) {
  //                     console.log("Error", error)
  //                     setBlocking(false)
  //                     enqueueSnackbar("Proses retrieve data PK-25 gagal, silakan coba lagi.", { variant: 'error' })
  //                     localStorage.setItem("first", true);
  //                     finishLogin(username, res, opr)
  //                 })
  //             })

  //             await Promise.all(promises)

  //         } catch (e) {
  //             console.log(JSON.stringify(e))
  //             setBlocking(false)
  //             localStorage.setItem("first", true);
  //             enqueueSnackbar("Checking data resource failed, silakan coba lagi.", { variant: 'error' })
  //             finishLogin(username, res, opr)
  //         } finally {
  //             console.log(dataRetrievePk)
  //             if(dataRetrievePk.length > 0){
  //                 saveRetrievePk(dataRetrievePk)
  //             }
  //             localStorage.setItem("retrievePk", JSON.stringify(dataRetrievePk))
  //             setBlocking(false)
  //             finishLogin(username, res, opr)
  //         }

  //     } else {
  //         localStorage.setItem("first", true);
  //         finishLogin(username, res, opr)
  //     }
  // }

  // const saveRetrievePk = async (retrievePkData, username) => {
  //     try {
  //         const promises = retrievePkData.map(async (el) => {
  //             const resRetreievePk = await axios.post(REACT_APP_PK_RETRIEVE_URL + 'pk/api/v1/save', el
  //                 // ,{
  //                 //     headers: {
  //                 //         Authorization: 'Basic ' + btoa('admin' + ':' + 'password'),
  //                 //         user_id : username
  //                 //     }
  //                 // }
  //             )
  //             .then((res) => {
  //                 console.log('407', res)
  //             })
  //             .catch(function (error) {
  //                 console.log("Error", error)
  //             })
  //         })

  //         await Promise.all(promises)

  //     } catch (e) {
  //         console.log(JSON.stringify(e))
  //     }
  // }

  const fetchData = async (
    selectUrl,
    dbname,
    wil_prov,
    id_kab,
    wil_kel,
    wil_rw,
    username,
    res,
    opr,
    rtRetrieve,
    usernameProses
  ) => {
    // const url_split = selectUrl.split('/')
    // const couchdb = url_split[url_split.length - 1]
    // console.log(selectUrl, 'select url')
    // console.log(dbname, 'dbname')
    // console.log(wil_prov, 'wil_prov')
    // console.log(wil_kel, 'wil_kel')
    // console.log(wil_rw, 'wil_rw')
    // console.log(usernameProses, 'usernameProses >>>')
    const idkec = 93;

    const query = await dataBkkbn.local.find({
      selector: {
        // periode_sensus: { $eq: '2021' }
        // _id: { $eq: '1617193181935p1109012020-01KPSUAKBARU' }
      },
    });

    const rw = wil_rw;
    let idRt = [];
    for (let i = 0; i < rw.length; i++) {
      let rt = rw[i].wil_rt;
      for (let j = 0; j < rt.length; j++) {
        idRt.push(+rt[j].id_rt);
      }
    }
    // console.log(idRt, 'cek id RT')
    // console.log(id_kab, '<<< Cek ID_KAB')
    // console.log(dataBkkbn.local, '<<< DATABKKBN.LOCAL')

    // ===== Delete local data - old doc =====
    try {
      // console.log(id_kab, 'id kab');
      const resDel = await axios.get(
        API_CONFIG_URL +
          "/pk/pwaConfig/getDeleteDataByIdKabupaten?idKab=" +
          id_kab,
        {
          // headers: { user_key: USER_KEY_PG }
          headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        }
      );
      // console.log(resDel.data, 'result delete');
      if (resDel.data.delete === true) {
        const dataLocal = await dataBkkbn.local.find({
          selector: { user_name: username },
        });
        // console.log(dataLocal.docs, 'docs');
        for (let index = 0; index < dataLocal.docs.length; index++) {
          const doc = dataLocal.docs[index];

          if (
            doc.user_name === username &&
            (doc.last_update === null ||
              !doc.hasOwnProperty("last_update") ||
              (doc.last_update !== null && doc.last_update < resDel.data.date))
          ) {
            await dataBkkbn.local.remove(doc._id, doc._rev, function (err) {
              if (err) {
                return console.log(err);
              } else {
                // console.log(doc._id, 'Document deleted successfully');
              }
            });
          }
        }
      }
    } catch (error) {}

    // console.log(query, 'query dataBkkbn')
    //delete local data - old doc
    // console.log(user, 'run check')
    for (const doc of query.docs) {
      // const x = idRt.filter(o => o === +doc.id_rt && doc.periode_sensus === "2022")
      const x = idRt.filter(
        (o) => o === +doc.id_rt && doc.periode_sensus === "2025"
      );
      if (x.length === 0) {
        if (doc.user_name === username) {
          dataBkkbn.local.remove(doc._id, doc._rev, function (err) {
            if (err) {
              return console.log(err);
            } else {
              console.log(doc._id, "Document deleted successfully");
            }
          });
        }
      } else {
        console.log("Data RT sesuai");
      }
    }

    //download old data from API if local data & server data = 0
    if (rtRetrieve.length > 0) {
      try {
        setBlocking(true);
        // console.log(localStorage.getItem("remote_base"), 'remote_base')
        // console.log(localStorage.getItem("db_name"), 'db_name')
        const url = selectUrl + "/" + dbname;
        const idKel = wil_kel.id_kelurahan;
        const idProv = wil_prov.id_provinsi;
        // const rw = wil_rw
        // console.log(idRtRetrieve, 'idRtRetrieve')
        // const res = await axios.get(url + '?user_key=' + USER_KEY_PG + '&idKelurahan=' + idKel + '&periodeSensus=2022' + '&username=' + user.metadata.name)
        // const { data } = await res;
        setPgsPutCdb(true);
        setTotalData(rtRetrieve.length);
        setLabelPut("Please wait, load inisial data from PK-25");
        let dtRetrieve = [];
        const promises = rtRetrieve.map(async (el) => {
          const resRetreievePk = await axios
            .post(
              REACT_APP_PK_RETRIEVE_URL +
                "pk/api/v1/retrievePk?username=" +
                usernameProses +
                "&idRt=" +
                el,
              {},
              {
                headers: {
                  Authorization: "Basic " + btoa("admin" + ":" + "password"),
                  // Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
                  user_id: username,
                },
              }
              // ,{
              //     headers: {
              //         Authorization: 'Basic ' + btoa('admin' + ':' + 'password'),
              //         user_id : username
              //     }
              // }
            )
            .then((res2) => {
              dtRetrieve = dtRetrieve.concat(res2.data.data);
              setCountPut((prev) => prev + 1);
            })
            .catch(function (error) {
              console.log("Error", error);
              enqueueSnackbar(
                "Proses retrieve data PK-25 gagal, silakan coba lagi.",
                { variant: "error" }
              );
            });
        });
        await Promise.all(promises);

        // for (let i = 0; i < rtRetrieve.length; i++) {
        //     let rt = []
        //     rt.push(rtRetrieve[i])

        //     const res = await axios.post(url + '/_retrieve?idProvinsi=' + idProv + '&idKelurahan=' + idKel + '&periodeSensus=2025' + '&username=' + usernameProses, rt, {
        //         // headers: { user_key: USER_KEY_PG }
        //         headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQ=' }
        //     })

        //     const { data } = await res
        //     console.log(data, 'data xxx')
        //     dtRetrieve = dtRetrieve.concat(data)
        //     // .then(async (response) => {
        //     //     // do something with response
        //     //     console.log(response, 'response get')

        //     // })
        //     // .catch((e) => {
        //     //     localStorage.setItem("first", true);
        //     //     setBlocking(false)
        //     //     finishLogin(username, res, opr)
        //     // })
        // }
        console.log(dtRetrieve, "dt retrieve");
        let totalD = dtRetrieve.length;
        // console.log(response.data,'proxy gateway retrieve')
        console.log(totalD, "totalD");
        localStorage.setItem("retrievePk", JSON.stringify(dtRetrieve));
        // if(dtRetrieve.length > 0){
        //     saveRetrievePk(dtRetrieve, username)
        // }

        // setPgsPutCdb(true)
        // setTotalData(totalD)
        if (totalD > 0) {
          try {
            let resp = [];
            let promises2 = [];
            let x = 0;
            //set remote
            for (let i = 0; i < totalD; i++) {
              // for(let obj of response.data){
              let obj = dtRetrieve[i];
              let x = 0;
              delete obj._rev;
              const localObj = {
                ...obj,
                status_sensus: "Tersimpan",
                periode_sensus: "2025",
                year_doc: "2024",
                last_update: Date.now(),
                submit: false,
              };
              const remoteObj = {
                ...obj,
                status_sensus: "",
                periode_sensus: "2025",
                year_doc: "2024",
                last_update: Date.now(),
                submit: false,
              };
              // console.log(localObj, 'lokalObj')
              await dataBkkbn["local"]
                .put(localObj)
                .then((response) => {
                  console.log(response, "response put");
                  // promises.push(
                  //     axios.put(url + '/' + remoteObj._id + '/_put?couchdb=' + couchdb + '&database-name=' + dbname + '&_id=' + remoteObj._id + "&idKec=" + idkec , remoteObj, {
                  //         // headers: { user_key: USER_KEY_PG }
                  //         headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQ=' }
                  //     }).then(response => {
                  //         // console.log(response, 'each response')
                  //         // let x = countPut
                  //         // x = x + 1
                  //         // console.log(x, 'xxx')
                  //         setCountPut((prev) => prev + 1)
                  //     }).catch((e) => {
                  //         // let x = countPut
                  //         // x = x + 1
                  //         setCountPut((prev) => prev + 1)
                  //         //     // setBlocking(false)
                  //     })
                  // )
                })
                .catch(async (e) => {
                  // x = 2
                  let selector = {
                    _id: { $eq: e.id },
                  };
                  // console.log(selector, 'find lokal & push')
                  const query = await dataBkkbn.local.find({
                    selector,
                  });
                  // console.log(query.docs[0], 'get by id')
                  let newRemoteObj = {
                    ...query.docs[0],
                    status_sensus: "",
                  };
                  delete newRemoteObj._rev;
                  // promises.push(
                  //     axios.put(url + '/' + newRemoteObj._id + '/_put?couchdb=' + couchdb + '&database-name=' + dbname + '&_id=' + newRemoteObj._id + "&idKec=" + idkec , newRemoteObj, {
                  //         // headers: { user_key: USER_KEY_PG }
                  //         headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQ=' }
                  //     }).then(response => {
                  //         // console.log(response, 'each response')
                  //         // let x = countPut
                  //         // x = x + 1
                  //         // console.log(x, 'xxx')
                  //         setCountPut((prev) => prev + 1)
                  //     }).catch((e) => {
                  //         setCountPut((prev) => prev + 1)
                  //     })
                  // )
                });
            }
            Promise.all(promises2).then(() => {
              setBlocking(false);
              finishLogin(username, res, opr);
            });
          } catch (e) {
            setBlocking(false);
            enqueueSnackbar(
              "Proses retrieve data PK-25 gagal, silakan coba lagi.",
              { variant: "error" }
            );
            localStorage.setItem("first", true);
            finishLogin(username, res, opr);
          }
        } else {
          console.log("Tidak ada data yg di retrieve");
          localStorage.setItem("first", true);
          setBlocking(false);
          finishLogin(username, res, opr);
        }
      } catch (e) {
        setBlocking(false);
        localStorage.setItem("first", true);
        enqueueSnackbar("Checking data resource failed, silakan coba lagi.", {
          variant: "error",
        });
        finishLogin(username, res, opr);
      }
    } else {
      localStorage.setItem("first", true);
      finishLogin(username, res, opr);
    }
  };

  const allowedUsernames = ["prob1904022016PEDINDANG"];

  const handleSubmit = async (e) => {
    e.preventDefault();

    // const isHttps = window.location.protocol === "https:";

    // if (isHttps && !allowedUsernames.includes(form.username)) {
    //   enqueueSnackbar("Username tidak diizinkan login di HTTPS", {
    //     variant: "error",
    //   });
    //   return;
    // }

    if (captcha) {
      const findErrors = validate();

      if (Object.values(findErrors).some((err) => err !== "")) {
        setError(findErrors);
      } else {
        setSubmitting(true);
        let username = form.username;
        // console.log(username, "<<<<< FORM USERNAME");
        let opr = false;
        if (username.substring(0, 3) == "opr") {
          // const splitName = username.split('_')
          // const splitName = username
          // console.log(splitName, "<<<<< SPLITNAME")
          // let name = splitName[0]
          // console.log(name, "<<<<< NAME")
          // if (splitName.length > 1) {
          //     // let setRw = "_" + splitName[splitName.length - 1]
          //     let setRw = "_" + splitName
          //     console.log(setRw, "<<<<< SETRW")
          //     name = username.split(setRw).join("");
          // }
          // username = name
          console.log("name => ", username);
          opr = true;
        }

        localStorage.setItem("opr", opr);

        // axios.post(`https://authservice-3scale-apicast-production.apps.tkp.platform.lintasarta.net:443/dev/auth/signin?user_key=5848e56474b2baefc07afe94bff01afa`,{
        axios
          .post(
            `${API_URL}/auth/signin?`,
            {
              username: username,
              password: form.password,
            },
            {
              headers: {
                withCredentials: true,
                "Content-Type": "application/json",
                // user_key: USER_KEY_AUTH
                Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
              },
            }
          )
          .then(async (res) => {
            if (res.status == "200") {
              // if(res.data.pbdkiDate){
              if (
                res.data.username == username ||
                res.data.usernameProses == username
              ) {
                // console.log("Login with API success ", res);
                localStorage.removeItem("dataServerCount");
                let kab = res.data.userProfile.wil_kabupaten
                  .original_nama_kabupaten
                  ? res.data.userProfile.wil_kabupaten.original_nama_kabupaten
                  : res.data.userProfile.wil_kabupaten.nama_kabupaten;
                let id_kab = res.data.userProfile.wil_kabupaten.id_kabupaten;
                let toLower = kab.toLowerCase();
                let remove = toLower.split(".").join("");
                let kabname = remove.replace(/ /g, "_");
                let selectedDB = kabname;
                let dbname = `data_bkkbn_${selectedDB}`;
                localStorage.setItem("db_name", dbname);
                let provId = res.data.userProfile.wil_provinsi.id_provinsi;
                let wil_provinsi = res.data.userProfile.wil_provinsi;
                let wil_kel = res.data.userProfile.wil_kelurahan;
                let wil_rw = res.data.userProfile.wil_rw;
                let rtRetrieve = res.data.rtRetrieve;
                // await setCdb(provId);
                // localStorage.getItem("remote_base")
                let selectUrl = localStorage.getItem("remote_base");
                //---locked pwa by kabupaten
                let locked = false;
                // lock_id_kabupaten.forEach(key => {
                //     if (key == idkab) {
                //         // localStorage.setItem("lock", false);
                //         locked = false
                //     }
                // })

                // console.log(locked, 'locked kab')

                localStorage.setItem("lock", locked);
                // if (res.data.flagFirstLogin) {
                //     localStorage.setItem("first", true);
                // } else {
                // const retrievePkData = await retrievePk(rtRetrieve, username, res, opr);
                const rsData = await fetchData(
                  selectUrl,
                  dbname,
                  wil_provinsi,
                  id_kab,
                  wil_kel,
                  wil_rw,
                  res.data.username,
                  res,
                  opr,
                  rtRetrieve,
                  res.data.usernameProses
                );
                // }

                //if(provId == 11 || provId == 32 || provId == 33 || provId == 30 || provId == 31 || provId == 19 || provId == 20 || provId == 29 || provId == 16 || provId == 7 || provId == 2 || provId == 18){ //beta
                // localStorage.setItem("lock", false);
                // // id_provinsi.map(key => {
                // //     if (key == provId) {
                // //         localStorage.setItem("lock", false);
                // //     }
                // // })

                // // dataKab.map(key => {
                // //     if (key.id_kabupaten == idkab) {
                // //         localStorage.setItem("lock", false);
                // //     }
                // // })

                // let id_rw = false
                // const splitRw = form.username.split('_')
                // if (username.substring(0, 3) == "opr") {

                //     if (splitRw.length > 1) {
                //         let setRw = splitRw[splitRw.length - 1].substring(4)
                //         let cek = res.data.userProfile.wil_rw.find(rw => { if (parseInt(rw.id_rw_bkkbn) === parseInt(setRw)) { return rw } return false })
                //         if (cek) {
                //             id_rw = cek.id_rw
                //         }
                //     }
                // }

                // localStorage.setItem("rw", id_rw);

                // let userCtx = {
                //     name: res.data.username,
                //     roles: res.data.userProfile.roles,
                //     id: res.data.id,
                //     ipAddress: res.data.ipAddress,
                //     jsessionid: res.data.jsessionid,
                //     flagFirstLogin: res.data.flagFirstLogin
                // }

                // let metadata = res.data.userProfile
                // setUser(user => ({
                //     ...user,
                //     userCtx,
                //     metadata: metadata
                // }))

                // if (!id_rw && opr) {
                //     if (splitRw.length > 1) {
                //         enqueueSnackbar("User tidak terdaftar", { variant: 'error' })
                //     }
                // }
                // setTimeout(() => {
                //     if (!id_rw && opr) {
                //         if (splitRw.length > 1) {
                //             setOnLogout(true)
                //         } else {
                //             setOnLogin(true)
                //         }
                //     } else {
                //         setOnLogin(true)
                //     }
                // }, 1000)
              } else {
                const newError = {};
                newError.password = res.data.message;
                setError(newError);
                setSubmitting(false);
              }
              // } else {
              //     enqueueSnackbar("Periode pendataan belum tersedia atau sedang di non aktifkan", { variant: 'warning' })
              //     setSubmitting(false);
              // }
            }
          })
          .catch(function (error) {
            console.log("Err => ", error);
            enqueueSnackbar("CONNECTION ERROR : " + error.message, {
              variant: "error",
            });
            setSubmitting(false);
          });
      }
    } else {
      enqueueSnackbar("Please check your Captcha", { variant: "error" });
    }
  };

  // === Function Set Couchdb Old ===
  // const setCdb = async (provId) => {
  //     let CDB1 = process.env.REACT_APP_COUCHDB_1_URL
  //     let CDB2 = process.env.REACT_APP_COUCHDB_2_URL
  //     let CDB3 = process.env.REACT_APP_COUCHDB_3_URL
  //     let CDB4 = process.env.REACT_APP_COUCHDB_4_URL

  //     cdb1.map(key => {
  //         if (key.id_provinsi == provId) {
  //             localStorage.setItem("remote_base", CDB1);
  //             // console.log("set to cdb1")
  //         }
  //     })

  //     cdb2.map(key => {
  //         if (key.id_provinsi == provId) {
  //             localStorage.setItem("remote_base", CDB2);
  //             console.log("set to cdb2")
  //         }
  //     })

  //     cdb3.map(key => {
  //         if (key.id_provinsi == provId) {
  //             localStorage.setItem("remote_base", CDB3);
  //             // console.log("set to cdb3")
  //         }
  //     })

  //     cdb4.map(key => {
  //         if (key.id_provinsi == provId) {
  //             localStorage.setItem("remote_base", CDB4);
  //             // console.log("set to cdb4")
  //         }
  //     })
  // }
  // === End Function Set Couchdb Old ===

  // === Function Set Couchdb New ===
  // const setCdb = async (provId) => {
  //     let selectCDB = '';
  //     const CDB1 = REACT_APP_COUCHDB_1_URL
  //     const CDB2 = REACT_APP_COUCHDB_2_URL
  //     const CDB3 = REACT_APP_COUCHDB_3_URL
  //     const CDB4 = REACT_APP_COUCHDB_4_URL

  //     try {
  //         const url = REACT_APP_API_CONFIG_URL + '/pk/pwaConfig/getCouchDbByIdProv?id_prov=' + provId;
  //         const res = await axios.get(url, {
  //             headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQ=', }
  //         })
  //         const { data } = await res;
  //         console.log("DATA >>>>> ", data)

  //         if (data.cdb === 'couchdb1') {
  //             selectCDB = CDB1
  //         } else if (data.cdb === 'couchdb2') {
  //             selectCDB = CDB2
  //         } else if (data.cdb === 'couchdb3') {
  //             selectCDB = CDB3
  //         } else if (data.cdb === 'couchdb4') {
  //             selectCDB = CDB4
  //         } else {
  //             cdb1.map(key => {
  //                 if (key.id_provinsi == provId) {
  //                     selectCDB = CDB1
  //                     // localStorage.setItem("remote_base", CDB1);
  //                     // console.log("set to cdb1")
  //                 }
  //             })

  //             cdb2.map(key => {
  //                 if (key.id_provinsi == provId) {
  //                     selectCDB = CDB2
  //                     // localStorage.setItem("remote_base", CDB2);
  //                     // console.log("set to cdb2")
  //                 }
  //             })

  //             cdb3.map(key => {
  //                 if (key.id_provinsi == provId) {
  //                     selectCDB = CDB3
  //                     // localStorage.setItem("remote_base", CDB3);
  //                     // console.log("set to cdb3")
  //                 }
  //             })

  //             cdb4.map(key => {
  //                 if (key.id_provinsi == provId) {
  //                     selectCDB = CDB4
  //                     // localStorage.setItem("remote_base", CDB4);
  //                     // console.log("set to cdb4")
  //                 }
  //             })
  //         }
  //     } catch (error) {
  //         cdb1.map(key => {
  //             if (key.id_provinsi == provId) {
  //                 selectCDB = CDB1
  //                 // localStorage.setItem("remote_base", CDB1);
  //                 // console.log("set to cdb1")
  //             }
  //         })

  //         cdb2.map(key => {
  //             if (key.id_provinsi == provId) {
  //                 selectCDB = CDB2
  //                 // localStorage.setItem("remote_base", CDB2);
  //                 // console.log("set to cdb2")
  //             }
  //         })

  //         cdb3.map(key => {
  //             if (key.id_provinsi == provId) {
  //                 selectCDB = CDB3
  //                 // localStorage.setItem("remote_base", CDB3);
  //                 // console.log("set to cdb3")
  //             }
  //         })

  //         cdb4.map(key => {
  //             if (key.id_provinsi == provId) {
  //                 selectCDB = CDB4
  //                 // localStorage.setItem("remote_base", CDB4);
  //                 // console.log("set to cdb4")
  //             }
  //         })
  //     }

  //     await localStorage.setItem('remote_base', selectCDB)
  // }
  // === End Function Set Couchdb New ===

  function onChangeCaptcha(value) {
    if (value) {
      //console.log("Captcha value:", value);
      setCaptcha(true);
    } else {
      console.log("invalid");
      setCaptcha(false);
    }
  }

  if (user.loading) {
    return <AppLoading />;
  }
  if (user.isLoggedIn) {
    // console.log(user, "isLoggin in login");
    const redirecTo =
      location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/";
    return <Redirect to={redirecTo} />;
  }

  return (
    <Container maxWidth="xs" className={classes.container}>
      {blocking ? (
        <div
          style={{
            display: "flex",
            minHeight: "100vh",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <b>
            <CircularProgress
              size={24}
              style={{ color: "#000", marginRight: "5px" }}
            />{" "}
            {labelPut}{" "}
            {pgsPutCdb && (
              <b>
                {countPut}/{totalData}
              </b>
            )}
          </b>
        </div>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} className={classes.textCenter}>
            <img src={logo} alt="logo" style={{ height: 70 }} />
          </Grid>
          <Grid item xs={12}>
            {/* {globalPermit ? */}
            <Paper
              className={classes.paper}
              style={{ borderLeft: "5px solid #9696ff" }}
            >
              <Typography variant="h5" component="h1" className={classes.title}>
                Login
              </Typography>
              {/* <div style={{textAlign: 'center'}}>
                        <span>Silakan masukkan username dan password</span>
                    </div> */}

              <form onSubmit={handleSubmit} noValidate>
                <TextField
                  variant="outlined"
                  id="username"
                  type="username"
                  name="username"
                  margin="normal"
                  label="Username"
                  fullWidth
                  required
                  value={form.username}
                  onChange={handleChange}
                  helperText={error.username}
                  error={error.username ? true : false}
                  disabled={isSubmitting}
                />
                <TextField
                  variant="outlined"
                  id="password"
                  type="password"
                  name="password"
                  margin="normal"
                  label="Password"
                  fullWidth
                  required
                  value={form.password}
                  onChange={handleChange}
                  helperText={error.password}
                  error={error.password ? true : false}
                  disabled={isSubmitting}
                />

                <div className="captcha">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={process.env.REACT_APP_SITE_KEY_CAPTCHA}
                    onChange={onChangeCaptcha}
                  />
                </div>

                <Grid container className={classes.buttons}>
                  <Grid item xs={12}>
                    {!isSubmitting ? (
                      <>
                        <Button
                          fullWidth
                          disabled={isSubmitting}
                          type="submit"
                          color="primary"
                          variant="contained"
                          size="large"
                          style={{ color: "white" }}
                        >
                          Login
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          fullWidth
                          disabled={isSubmitting}
                          type="submit"
                          color="primary"
                          variant="contained"
                          size="large"
                          style={{ color: "white" }}
                        >
                          <CircularProgress />
                        </Button>
                      </>
                    )}
                  </Grid>
                </Grid>
              </form>
              <div
                style={{
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginTop: "",
                  padding: "10px 0 0",
                  textAlign: "justify",
                }}
              >
                Aplikasi <b>Pemutakhiran PK-25</b> memuat data yang bersifat
                rahasia. Segala tindakan pencurian data dan tindakan ilegal
                lainnya akan diproses secara hukum yang berlaku.
              </div>
            </Paper>

            {/* :
                    <div>
                        <img src={periode} width="100%" alt="periode" style={{ borderRadius: '4px' }} />
                    </div>
                 } */}
          </Grid>
          <div
            xs="12"
            style={{ textAlign: "center", margin: "20px", width: "100%" }}
          >
            <img
              src={logoBkkbn}
              alt="bkkbn"
              width="185"
              height="40"
              style={{ marginRight: "2rem" }}
            />
            <img src={logoKominfo} alt="kominfo" width="60" height="40" />
          </div>
          <Grid item xs={12} className={classes.textCenter}>
            <Typography style={{ fontSize: "11px" }}>
              Copyright &copy; 2021 - {new Date().getFullYear()} Kementerian
              Kependudukan dan Pembangunan Keluarga / BKKBN | v{Version.version}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}

export default Login;
